import { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Container,
  Button,
  IconButton,
  CircularProgress
} from '@material-ui/core';
import { Skeleton, Alert } from '@material-ui/lab';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import DoneIcon from '@material-ui/icons/Done';
import SaveAltOutlinedIcon from '@material-ui/icons/SaveAltOutlined';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import RepeatIcon from '@material-ui/icons/Repeat';
import ClearIcon from '@material-ui/icons/Clear';
import { InputsContainer, InputsContent, PagadoriaAccordionContainer, PagadoriaSummaryInfo } from '../EditarProposta/styles';
import PreviewFile from '../../../components/PreviewFile/PreviewFile';
import EditCommisionModal from '../../../components/EditCommisionModal';
import SecondCopyCommissionModal from '../../../components/SecondCopyCommissionModal';
import EditCommissionStatusModal from '../../../components/EditCommissionStatusModal';
import { IProposalWeBroPayInfo } from '../../../services/CommissionSalesService';

interface PessoaFisicaProps {
  filesUrl: any[];
  weBroPayData: {
    weBroPaySalesInfo: IProposalWeBroPayInfo | null;
    setWeBroPaySalesInfo: (weBroPaySalesInfo: IProposalWeBroPayInfo) => void;
    reloadWeBroPaySales: () => void;
    empElegivelPagadoria: boolean;
    isProposalApproved: boolean;
    idProposalApp: string;
    codMega: string;
    isLoadingWeBroPaySales: boolean;
  }
}

const PessoaFisica = (props: PessoaFisicaProps) => {
  const { filesUrl, weBroPayData } = props;

  const [editCommissionModalOpen, setEditCommissionModalOpen] = useState(false);
  const [secondCopyCommissionModalOpen, setSecondCopyCommissionModalOpen] = useState(false);
  const [editCommissionStatusModalOpen, setEditCommissionStatusModalOpen] = useState(false);
  const [hasWeBroPaySales, setHasWeBroPaySales] = useState(false);
  const [selectedSaleId, setSelectedSaleId] = useState('');
  const [selectedSaleStatus, setSelectedSaleStatus] = useState<'LIBERADO' | 'BLOQUEADO'>('LIBERADO');
  const [selectedInstallmentId, setSelectedInstallmentId] = useState('');
  const [selectedInstallmentCurrentDueDate, setSelectedInstallmentCurrentDueDate] = useState('');
  const [hasPaidInstallments, setHasPaidInstallments] = useState(weBroPayData.weBroPaySalesInfo?.sales.some(sale => sale.installments.some(installment => installment.pago)));

  let totalParcelaCount = 0;

  useEffect(() => {
    setHasWeBroPaySales(weBroPayData.weBroPaySalesInfo !== null);
    setHasPaidInstallments(weBroPayData.weBroPaySalesInfo?.sales.some(sale => sale.installments.some(installment => installment.pago)));
  }, [weBroPayData.weBroPaySalesInfo]);

  const handleWeBroPaySalesInfoUpdate = (data: IProposalWeBroPayInfo) => {
      weBroPayData.setWeBroPaySalesInfo(data);
  };

  const checkedAnexos = (arr: any, tag: string) => {
    let arrayFiltered = arr.filter((el: any) => {
      if (el.tag === tag) {
        return true;
      }
      return false;
    });
    if (arrayFiltered.length >= 1 && arrayFiltered.length <= 15) {
      return <DoneIcon className="checked" />;
    }
    if (arrayFiltered.length > 15) {
      return (
        <>
          <ClearIcon className="wrong" />
          <p style={{ fontSize: 11 }}>Muitos arquivos anexados!</p>
        </>
      );
    }
    return (
      <>
        <ClearIcon className="wrong" />
        <p style={{ fontSize: 11 }}>Nenhum documento anexado!</p>
      </>
    );
  };

  const formatWeBroPayDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('pt-BR');
  }

  return (
    <>
      <InputsContent className="acordion-1">
        <Accordion className="acordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="acordion-summary"
          >
            <Typography className="anexar-documentos">
              <AttachFileIcon />
              Carta Proposta (CP) e Documentos Pessoais (RG ou CNH não vencida e
              CPF, frente e verso)
              {checkedAnexos(filesUrl, 'personal')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <InputsContainer className="upload-fotos">
              {filesUrl.map((el: any) => {
                const urlSplited = el.document.signedUrl.split('.');
                const nome = el.document.signedUrl.split('/');
                let isImage = false;
                if (
                  urlSplited[urlSplited.length - 1] === 'png' ||
                  urlSplited[urlSplited.length - 1] === 'jpg' ||
                  urlSplited[urlSplited.length - 1] === 'jpeg' ||
                  urlSplited[urlSplited.length - 1] === 'svg'
                ) {
                  isImage = true;
                }
                if (
                  el.tag === 'personal' ||
                  el.tag === 'signed_cp' ||
                  el.tag === 'signed-cp'
                ) {
                  return (
                    <PreviewFile
                      url={el.document.signedUrl}
                      nome={nome[nome.length - 1]}
                      isImage={isImage}
                    />
                  );
                }
                return <></>;
              })}
            </InputsContainer>
          </AccordionDetails>
        </Accordion>
      </InputsContent>
      <InputsContent className="acordion-1">
        <Accordion className="acordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="acordion-summary"
          >
            <Typography className="anexar-documentos">
              <AttachFileIcon />
              Comprovante de estado civil{' '}
              {checkedAnexos(filesUrl, 'estado_civil')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <InputsContainer className="upload-fotos">
              {filesUrl.map((el: any) => {
                const urlSplited = el.document.signedUrl.split('.');
                const nome = el.document.signedUrl.split('/');
                let isImage = false;
                if (
                  urlSplited[urlSplited.length - 1] === 'png' ||
                  urlSplited[urlSplited.length - 1] === 'jpg' ||
                  urlSplited[urlSplited.length - 1] === 'jpeg' ||
                  urlSplited[urlSplited.length - 1] === 'svg'
                ) {
                  isImage = true;
                }
                if (el.tag === 'estado_civil') {
                  return (
                    <PreviewFile
                      url={el.document.signedUrl}
                      nome={nome[nome.length - 1]}
                      isImage={isImage}
                    />
                  );
                }
                return <></>;
              })}
            </InputsContainer>
          </AccordionDetails>
        </Accordion>
      </InputsContent>
      <InputsContent className="acordion-1">
        <Accordion className="acordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="acordion-summary"
          >
            <Typography className="anexar-documentos">
              <AttachFileIcon />
              Comprovante de residência (Até 90 dias)
              {checkedAnexos(filesUrl, 'comp_residencial')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <InputsContainer className="upload-fotos">
              {filesUrl.map((el: any) => {
                const urlSplited = el.document.signedUrl.split('.');
                const nome = el.document.signedUrl.split('/');
                let isImage = false;
                if (
                  urlSplited[urlSplited.length - 1] === 'png' ||
                  urlSplited[urlSplited.length - 1] === 'jpg' ||
                  urlSplited[urlSplited.length - 1] === 'jpeg' ||
                  urlSplited[urlSplited.length - 1] === 'svg'
                ) {
                  isImage = true;
                }
                if (el.tag === 'comp_residencial') {
                  return (
                    <PreviewFile
                      url={el.document.signedUrl}
                      nome={nome[nome.length - 1]}
                      isImage={isImage}
                    />
                  );
                }
                return <></>;
              })}
            </InputsContainer>
          </AccordionDetails>
        </Accordion>
      </InputsContent>

      <InputsContent className="acordion-1">
        <Accordion className="acordion">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="acordion-summary"
          >
            <Typography className="anexar-documentos">
              <AttachFileIcon />
              Comprovante de renda
              {checkedAnexos(filesUrl, 'comp_renda')}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <InputsContainer className="upload-fotos">
              {filesUrl.map((el: any) => {
                const urlSplited = el.document.signedUrl.split('.');
                const nome = el.document.signedUrl.split('/');
                let isImage = false;
                if (
                  urlSplited[urlSplited.length - 1] === 'png' ||
                  urlSplited[urlSplited.length - 1] === 'jpg' ||
                  urlSplited[urlSplited.length - 1] === 'jpeg' ||
                  urlSplited[urlSplited.length - 1] === 'svg'
                ) {
                  isImage = true;
                }
                if (el.tag === 'comp_renda') {
                  return (
                    <PreviewFile
                      url={el.document.signedUrl}
                      nome={nome[nome.length - 1]}
                      isImage={isImage}
                    />
                  );
                }
                return <></>;
              })}
            </InputsContainer>
          </AccordionDetails>
        </Accordion>
      </InputsContent>

      {weBroPayData.isLoadingWeBroPaySales && (
        <InputsContent className="acordion-1">
          <Accordion className="acordion">
            <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className="acordion-summary-pagadoria"
          >
            <PagadoriaSummaryInfo>
              <Typography className="anexar-documentos">
                <AccountBalanceWalletOutlinedIcon />
              </Typography>
              <Typography className="pagadoria-accordion-title">Pagadoria - Status Comissões</Typography>
                  <Container>
                    <Typography variant="subtitle2">Corretor(a)</Typography>
                    <Skeleton width={200} />
                  </Container>
                  <Container>
                    <Typography variant="subtitle2">Cliente</Typography>
                    <Skeleton width={200} />
                  </Container>
            </PagadoriaSummaryInfo>
          </AccordionSummary>
          <AccordionDetails className="pagadoria">
            <PagadoriaAccordionContainer>
              <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px 0' }}>
                <CircularProgress style={{ marginBottom: 16 }} />
                <Typography variant="body1">Carregando informações das comissões...</Typography>
              </Container>
            </PagadoriaAccordionContainer>
          </AccordionDetails>
        </Accordion>
      </InputsContent>
      )}

      {!weBroPayData.isLoadingWeBroPaySales && weBroPayData.empElegivelPagadoria && (
        <>
          {weBroPayData.weBroPaySalesInfo ? (
            <>
              <EditCommisionModal
                isModalOpen={editCommissionModalOpen}
                onClose={() => setEditCommissionModalOpen(false)}
                idProposalApp={weBroPayData.idProposalApp}
                onSuccess={() => {
                  weBroPayData.reloadWeBroPaySales()
                  setEditCommissionModalOpen(false)
                }}
                hasWebropaySales={hasWeBroPaySales}
                codMega={weBroPayData.codMega}
                preFilledValues={{
                  isAutonomous: weBroPayData.weBroPaySalesInfo.documentoRecebedor.length === 11,
                  totalValue: weBroPayData.weBroPaySalesInfo.valorTotal,
                  installmentsAmount: weBroPayData.weBroPaySalesInfo.sales.reduce((acc, sale) => acc + sale.installments.length, 0),
                  firstDueDate: weBroPayData.weBroPaySalesInfo.sales[0].installments[0].dataVencimentoParcela,
                  document: weBroPayData.weBroPaySalesInfo.documentoRecebedor
                }}
              />
              <EditCommissionStatusModal
                isModalOpen={editCommissionStatusModalOpen}
                onClose={() => setEditCommissionStatusModalOpen(false)}
                weBroPaySalesInfo={weBroPayData.weBroPaySalesInfo}
                currentStatus={selectedSaleStatus}
                idVenda={selectedSaleId}
                setWeBroPaySalesInfo={handleWeBroPaySalesInfoUpdate}
              />
              <SecondCopyCommissionModal
                isModalOpen={secondCopyCommissionModalOpen}
                onClose={() => {
                  setSecondCopyCommissionModalOpen(false)
                }}
                onSuccess={() => {
                  weBroPayData.reloadWeBroPaySales()
                  setSecondCopyCommissionModalOpen(false)
                }}
                idVenda={selectedSaleId}
                idParcela={selectedInstallmentId}
                currentDueDate={formatWeBroPayDate(selectedInstallmentCurrentDueDate)}
              />
              <InputsContent className="acordion-1">
                <Accordion className="acordion">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="acordion-summary-pagadoria"
                  >
                    <PagadoriaSummaryInfo>
                      <Typography className="anexar-documentos">
                        <AccountBalanceWalletOutlinedIcon />
                      </Typography>
                      <Typography className="pagadoria-accordion-title">Pagadoria - Status Comissões</Typography>
                      {!weBroPayData.isLoadingWeBroPaySales && hasWeBroPaySales && (
                        <>
                          <Container>
                            <Typography variant="subtitle2">Corretor(a)</Typography>
                            <Typography variant="body1">{weBroPayData.weBroPaySalesInfo.nomeRecebedor}</Typography>
                          </Container>
                          <Container>
                            <Typography variant="subtitle2">Cliente</Typography>
                            <Typography variant="body1">{weBroPayData.weBroPaySalesInfo.nomeCliente}</Typography>
                          </Container>
                        </>
                      )}

                      {!weBroPayData.isLoadingWeBroPaySales && !hasWeBroPaySales && (
                        <Container>
                          <Typography variant="body1">Nenhuma comissão encontrada</Typography>
                        </Container>
                      )}
                    </PagadoriaSummaryInfo>
                  </AccordionSummary >
                  <AccordionDetails className="pagadoria">
                    {!weBroPayData.isLoadingWeBroPaySales && hasWeBroPaySales && (
                      <PagadoriaAccordionContainer>
                        {hasPaidInstallments && (
                          <Alert severity="warning" className="alert-warning-paid-installment">
                            Após o pagamento de uma parcela, não é possível emitir a segunda via da mesma nem modificar as condições da proposta.
                          </Alert>
                        )}
                        {weBroPayData.weBroPaySalesInfo.sales.map((sale: any) => (
                          <Container key={sale.idVenda} className={`card-venda ${sale.pagamentoLiberado ? 'liberado' : 'bloqueado'}`}>
                          <Button
                            className="status-chip"
                            endIcon={<EditRoundedIcon fontSize="small" />}
                            onClick={() => {
                              setEditCommissionStatusModalOpen(true)
                              setSelectedSaleId(sale.idVenda)
                              setSelectedSaleStatus(sale.pagamentoLiberado ? 'LIBERADO' : 'BLOQUEADO')
                            }}
                          >
                            {sale.pagamentoLiberado ? 'Liberado' : 'Bloqueado'}
                          </Button>
                          {sale.installments.map((parcela: any) => {
                            totalParcelaCount += 1;
                            return (
                              <Container key={parcela.idParcela} className="parcela-row">
                                <Container className="coluna">
                                  <IconButton aria-label="download" edge="start" color="inherit" href={parcela.urlBoleto} target="_blank">
                                    <SaveAltOutlinedIcon fontSize="medium" />
                                  </IconButton>
                                </Container>
                                <Typography>{totalParcelaCount}°</Typography>

                                <Container className="coluna value-column">
                                  <Typography className="valor">
                                    {new Intl.NumberFormat('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL'
                                    }).format(parcela.valor)}
                                  </Typography>
                                  <Typography variant="body2">Valor Parcela</Typography>
                                </Container>

                                <Container className="coluna status-column">
                                  <Typography className={`status ${parcela.pago ? 'pago' : 'pendente'}`}>
                                    {parcela.pago ? 'Pago' : 'Pendente'}
                                  </Typography>

                                  {parcela.pago ? (
                                    <Typography variant="body2">
                                      Pago em {formatWeBroPayDate(parcela.dataPagamentoParcela)}
                                    </Typography>
                                  ) : (
                                    <Typography variant="body2">
                                      Pagamento Cliente
                                    </Typography>
                                  )}
                                </Container>

                                <Container className="coluna due-date-column">
                                  <Typography className="valor">
                                    {formatWeBroPayDate(parcela.dataVencimentoParcela)}
                                  </Typography>
                                  <Typography variant="body2">Vencimento</Typography>
                                </Container>

                                <Container className="coluna">
                                  <Button
                                    variant="outlined"
                                    startIcon={<RepeatIcon />}
                                    className="botao-segunda-via"
                                    disabled={parcela.pago}
                                    onClick={() => {
                                      setSecondCopyCommissionModalOpen(true)
                                      setSelectedSaleId(sale.idVenda)
                                      setSelectedInstallmentId(parcela.idParcela)
                                      setSelectedInstallmentCurrentDueDate(parcela.dataVencimentoParcela)
                                    }}
                                  >
                                    Emitir 2° Via
                                  </Button>
                                </Container>
                              </Container>
                            );
                          })}
                        </Container>
                      ))}

                      <Container className="footer-accordion-content">
                        <Typography className="total-comissao">
                          Comissão Total <strong>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL'
                            }).format(weBroPayData.weBroPaySalesInfo.valorTotal || 0)}
                          </strong>
                        </Typography>

                        {(weBroPayData.isProposalApproved && !hasPaidInstallments) &&(
                          <div className="button-container">
                            <Button
                              variant="contained"
                              startIcon={<EditRoundedIcon />}
                              onClick={() => setEditCommissionModalOpen(true)}
                            >
                              Editar condições
                            </Button>
                          </div>
                        )}
                      </Container>
                    </PagadoriaAccordionContainer>
                  )}
                  {!weBroPayData.isLoadingWeBroPaySales && !hasWeBroPaySales && (
                    <PagadoriaAccordionContainer>
                      <Container className="no-commission-text">
                        <Typography variant="subtitle1">Não existe nenhuma comissão WeBroPay atrelada à proposta.</Typography>
                      </Container>
                      <Container disableGutters className="create-commission-footer">
                        <Button
                          variant="contained"
                          startIcon={<EditRoundedIcon />}
                          onClick={() => setEditCommissionModalOpen(true)}
                        >
                          Criar comissão
                        </Button>
                      </Container>
                    </PagadoriaAccordionContainer>
                  )}
                  </AccordionDetails>
                </Accordion >
              </InputsContent >
            </>
          ) : (
            <>
              <EditCommisionModal
                isModalOpen={editCommissionModalOpen}
                onClose={() => setEditCommissionModalOpen(false)}
                idProposalApp={weBroPayData.idProposalApp}
                hasWebropaySales={hasWeBroPaySales}
                onSuccess={() => {
                  weBroPayData.reloadWeBroPaySales()
                  setEditCommissionModalOpen(false)
                }}
                codMega={weBroPayData.codMega}
                preFilledValues={{
                  isAutonomous: false,
                  totalValue: 0,
                  installmentsAmount: 1,
                  firstDueDate: new Date().toISOString().split('T')[0],
                  document: ''
                }}
              />
              <InputsContent className="acordion-1">
                <Accordion className="acordion">
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    className="acordion-summary-pagadoria"
                  >
                    <PagadoriaSummaryInfo>
                      <Typography className="anexar-documentos">
                        <AccountBalanceWalletOutlinedIcon />
                      </Typography>
                      <Typography className="pagadoria-accordion-title">Pagadoria - Status Comissões</Typography>
                    </PagadoriaSummaryInfo>
                  </AccordionSummary>
                  <AccordionDetails className="pagadoria">
                    <PagadoriaAccordionContainer>
                      <Container className="no-commission-text">
                        <Typography variant="subtitle1">Não existe nenhuma comissão WeBroPay atrelada à proposta.</Typography>
                        {!weBroPayData.isProposalApproved && (
                          <Typography variant="subtitle1">Para realizar a criação das comissões é necessário aprovar a proposta.</Typography>
                        )}
                      </Container>
                      {weBroPayData.isProposalApproved && (
                        <Container disableGutters className="create-commission-footer">
                          <Button
                            variant="contained"
                            startIcon={<EditRoundedIcon />}
                            onClick={() => setEditCommissionModalOpen(true)}
                          >
                            Criar comissão
                          </Button>
                        </Container>
                      )}
                    </PagadoriaAccordionContainer>
                  </AccordionDetails>
                </Accordion>
              </InputsContent>
            </>
          )}
        </>
      )}

    </>
  );
};

export default PessoaFisica;
